import ContactView from './contact/ContactView';
import ContactEdit from './contact/ContactEdit';

import ProfileView from './profile/ProfileView';
import ProfileEdit from './profile/ProfileEdit';

import LanguagesView from './languages/LanguagesView';
import LanguagesEdit from './languages/LanguagesEdit';

import CertificateView from './certificates/CertificatesView';
import CertificateEdit from './certificates/CertificatesEdit';

import WorkHistoryView from './work_history/WorkHistoryView';
import WorkHistoryEdit from './work_history/WorkHistoryEdit';

import VulnerableSectorCheckView from './vulnerable_sector_check/VulnerableSectorCheckView';
import VulnerableSectorCheckEdit from './vulnerable_sector_check/VulnerableSectorCheckEdit';

import AgreementView from './agreement/AgreementView';

export default {

  ContactView,
  ContactEdit,

  ProfileView,
  ProfileEdit,

  LanguagesView,
  LanguagesEdit,

  CertificateView,
  CertificateEdit,

  WorkHistoryView,
  WorkHistoryEdit,

  VulnerableSectorCheckView,
  VulnerableSectorCheckEdit,

  AgreementView,
};
